/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {$SetVisibility, $Sprite, $Button, FC, ButtonProps} from '@gongxigames/framework/core/fragments/BuilderY';
import {BUTTON_STATES} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';
import {Rectangle} from 'pixi.js';

export type $AutoplayStartButtonProps = Omit<ButtonProps, 'name' | 'hitArea' | 'children'>;

export const $AutoplayStartButton: FC<$AutoplayStartButtonProps> = (props) => {
    const {action, responsive} = props;
    const hitArea = new Rectangle(-742/2, -134/2, 742, 134);

    const stateComponents = BUTTON_STATES.map(state =>{
        const stylePreset = state === 'focused' ? 'IN_BUTTON_TEXT_FOCUSED': 'IN_BUTTON_TEXT';
        const style = state === 'pressed' ? {fontSize: 76}: state === 'disabled' ? {fill: '#8d8d8d'} : undefined;

        return <$Sprite name={state} anchor={0.5} texture={`autoplay_btn_${state}_sys_ui`}>
            <$UIText
                localeID='autoplayStartText'
                name='autoplayStartButton'
                stylePreset={stylePreset}
                style={style}
                maxWidth={700}
                maxHeight={120}
            />
        </$Sprite>;
    });

    return <$Button
        {...props}
        name='autoplay_btn'
        hitArea={hitArea}
        action={action}
        responsive={responsive}
    >{(props) => {
            return <$SetVisibility selector={props.selector}>
                {stateComponents}
            </$SetVisibility>;
        }}</$Button>;
};
